export interface TripLegException {
  description: string;
  isActive: boolean;
  tripLegExceptionID: number;
  tripLegExceptionBC: string;
  tripLegExceptionName: string;
}

export enum TripLegExceptionBC {
  OpenSameDay = 'OPENSAMEDAY',
  NoDriver = 'NODRIVER',
  DriverNotOnline = 'DRIVERNOTONLINE',
  DriverLate = 'DRIVERLATE',
  EtaNotUpdating = 'ETANOTUPDATING',
  ReadyInvoice = 'READYINVOICE',
}
